import React, { memo, useEffect, useMemo, useRef, useState } from 'react'
import { FinalizarOrcamento } from "./FinalizarOrcamento";
import { obterParametros, obterParametrosPorOidItem } from "../../use-cases/parametro/obterParametros";
import { Parametro, ParametroPorItem } from "../../types/Parametro";
import microuniversoApi from "../../api/microuniversoApi";
import { useAppSelector } from "../../redux/hooks";
import {
    CodigoPergunta,
    DadosFinalizar,
    DadosFinalizarOrcamento,
    LiberarPendencia,
    RespostaPergunta,
    Situacao
} from "../../types/FinalizarOrcamento";
import globalMU from "../../../globalMU";
import { tratamentoErroPadrao } from "../../use-cases";
import { atualizarDadosOrcamento } from "../../use-cases/orcamento/atualizarDadosOrcamento";
import { liberarPendenciaOrcamento } from "../../use-cases/orcamento/liberarPendenciaOrcamento";
import { salvarOrcamento } from "../../use-cases/orcamento/salvarOrcamento";
import { OrcamentoConcluidoContainer } from "../itens-orcamento/orcamento-concluido/orcamentoConcluidoContainer";
import { Vendedor } from "../../types/Vendedor";
import { IOrcamento } from "../../types/IOrcamento";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { TelaCadastroIndicadoresContainer } from "../comissoes/cadastro-indicador/TelaCadastroIndicadoresContainer";
import { TelaComissoesContainer } from "../comissoes/TelaComissoesContainer";
import { Breadcrumb2 } from '../breadcrumb2/Breadcrumb2';
import store from 'app/redux/store/store';
import { gravarRespostaAction, limparRespostasAction } from 'app/redux/respostasFinalizacaoOrcamentoSlice';
import { DisponibilidadeCapacidadeCargaContainer } from './disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeCargaContainer';
import { limparInformacoesOrcamentoAction, sobrescreverInformacoesAction } from 'app/redux/orcamentoSlice';
import { PesquisarClienteContainer } from '../pesquisa-cliente/PesquisarClienteContainer';
import { atualizarOrcamento } from 'app/use-cases/orcamento/atualizarOrcamento';
import { ResponsaveisServicoAgregado } from '../servicos-agregados-responsaveis/ResponsaveisServicosAgregados';
import { ItensOrcamentoContainer } from '../itens-orcamento/ItensOrcamentoContainer';

export const FinalizarOrcamentoContainer = memo(() => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])

    // Mesmo padrão de orcamentoConcluidoContainer.tsx: sinaliza para _BaseInterno.cshtml
    // esconder o BaseInterno_BotaoFlutuanteCestaProdutos enquanto esta tela (incluindo a
    // conclusão do orçamento, renderizada como filha aqui) estiver montada.
    useEffect(() => {
        sessionStorage.setItem('finalizandoOrcamento', "true")
        return () => {
            sessionStorage.removeItem('finalizandoOrcamento')
        }
    }, [])

    const orcamento = useAppSelector(store => store.orcamento)
    const respostasFinalizacaoOrcamento = useAppSelector(store => store.respostasFinalizacaoOrcamento)
    const aguardandoProcessamento = useAppSelector(store => store.aguardandoProcessamento)
    

    const [tela, setTela] = useState<"FINALIZAR_ORCAMENTO" | "ORCAMENTO_CONCLUIDO">("FINALIZAR_ORCAMENTO")
    const [vendedorGerente, setVendedorGerente] = useState<boolean>(false)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 431595
    const [dadosFinalizarOrcamento, setDadosFinalizarOrcamento] = useState<DadosFinalizar>({
        DadosFinalizarOrcamento: {
            ObrigatorioInformarMotivoLiberacaoPendencias: true,
        }
    } as DadosFinalizar)
    const [dadosOrcamentoFinalizado, setDadosOrcamentoFinalizado] = useState<IOrcamento>({} as IOrcamento)
    const [vendedorLogado, setVendedorLogado] = useState<Vendedor>({} as Vendedor)
    const [dadosCarregados, setDadosCarregados] = useState(false)
    const [comanda, setComanda] = useState(orcamento?.NumeroComanda ?? "");
    //const [respostasPerguntas, setRespostasPerguntas] = useState<{[key: CodigoPergunta] : RespostaPergunta}>({})
    const [processando, setProcessando] = useState(false)

    const obterVendedor = async () => {
        const vendedor = await microuniversoApi.Vendedor.ObterVendedorAutenticado()
        if (isMounted.current) {
            setVendedorLogado(vendedor)
            if (vendedor) {
                const dados = await microuniversoApi.Vendedor.vendedorGerente(vendedor.Codigo)
                if (isMounted.current) {
                    setVendedorGerente(dados.Gerente)
                }
            }
        }
    }

    const atualizarParametros = async () => {
        const params = await obterParametros({
                nomes: [
                    "ORCAMENTO_COM_SUPERVISAO",
                    //"ORCAMENTO_COM_SUPERVISAO_POR_FILIAL",
                    "ORC_APENAS_ORÇAMENTO",
                    //"UTILIZA_GERENCIAMENTO_CAPACIDADE_CARGA",
                    "BLOQUEAR_INCLUSAO_DE_ORCAMENTO_SEM_CLIENTE", // filial do usuario logado
                ]
            })
        const paramsPorFilial = await obterParametrosPorOidItem({
                  nomes: [
                    "NAO_PERMITIR_VENDA_PRECO_OFERTA_ITEM_SEM_RESERVA_ESTOQUE", // 433263
                    "ORCAMENTO_COM_SUPERVISAO_POR_FILIAL", 
                    "UTILIZA_GERENCIAMENTO_CAPACIDADE_CARGA",
                ],
                  oidItem: orcamento.OidFilialOrcamento
                })
        if (isMounted.current) {
            setParametros(params)
            setParametrosPorFilial(paramsPorFilial)
        }
    }
    const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor
    const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor; // 433263

    const mostrarFormLiberarPendencias = useMemo(
        () => (orcamento.ItensOrcamento ?? []).filter(i => !i.PendenciaLocalRetirada).length > 0,
        [orcamento.ItensOrcamento]
    )
    const mudarSituacaoOrcamento = async (situacao: Situacao) => {
        try {
            globalMU.blockUI()
            await atualizarDadosOrcamento({
                ...orcamento,
                Situacao: situacao.Codigo,
                NumeroComanda: comanda
            })
            await obterDadosFinalizarOrcamento()

            store.dispatch(sobrescreverInformacoesAction({ CodigoSituacaoOrcamentoInformada: situacao.Codigo, NumeroComanda: comanda }))

            globalMU.unblockUI()
        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }
    }

    const obterDadosFinalizarOrcamento = async () => {
        try {
            globalMU.blockUI()
            
            const dados = await microuniversoApi.Orcamento.buscarDadosFinalizarOrcamento(orcamento)
            
            const resultado = dados?.DadosFinalizarOrcamento as DadosFinalizarOrcamento;
            // Procurar por inconsistências e verificar se há respostas correspondentes no respostasFinalizacaoOrcamento
            resultado?.Inconsistencias?.forEach(x => {
                x.Inconsistencias?.forEach(y => {
                    if (respostasFinalizacaoOrcamento[y.Codigo]) {
                        y.Resposta = respostasFinalizacaoOrcamento[y.Codigo];
                    }
                });
            });

            if (isMounted.current) {
                setDadosFinalizarOrcamento({...dados, DadosFinalizarOrcamento: resultado});
                setDadosCarregados(true)
            }
            globalMU.unblockUI()
        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }
    }

    const salvar = async () => {
        try {
            setProcessando(true)
            globalMU.blockUI()
            globalMU.blockScreen()
            const dados = await microuniversoApi.Orcamento.salvar({ ...orcamento, Inconsistencias: dadosFinalizarOrcamento?.DadosFinalizarOrcamento?.Inconsistencias, NumeroComanda: comanda})


            if (dados && !(dados as any).HasErrors) {
                if (isMounted.current) {
                    setDadosOrcamentoFinalizado(dados)
                    setTela("ORCAMENTO_CONCLUIDO")
                }
                store.dispatch(sobrescreverInformacoesAction({ Situacao: dados.Situacao, DescricaoSituacao: dados.DescricaoSituacao }))
                store.dispatch(limparRespostasAction())
                
                $(".main-sidebar").remove();

		        // try 
		        // {
		        //     store.dispatch(limparInformacoesOrcamentoAction()) // 458014
		        // } catch (error) {
		        //     console.log(error)
		        // }
            } else {
                setProcessando(false)
                let atualizouOrcamento = false

                if ((dados as any).Error.Error === 'Informe o profissional INTERNO/EXTERNO') {
                    renderizarComponentReact(<TelaComissoesContainer />, "conteudo-pagina", true)
                }
            
                if ((dados as any).Error.Error.includes('O cliente não possui mais nenhum saldo de cashback.')) {
                    atualizarOrcamento()
                    atualizouOrcamento = true
                }
                if (valorParametroPorFilial("NAO_PERMITIR_VENDA_PRECO_OFERTA_ITEM_SEM_RESERVA_ESTOQUE") == "S" 
                    && (dados as any).Error.WarnMessage
                    && (dados as any).Error.WarnMessage.includes('Preços dos produtos em oferta não autorizados foram retirados da oferta')
                ) 
                {
                    if (!atualizouOrcamento)
                    {
                        atualizarOrcamento() // 431595
                        atualizouOrcamento = true
                    }
                    renderizarComponentReact(<FinalizarOrcamentoContainer />, "conteudo-pagina", true)
                }

                if((dados as any).Error.Error.includes('Não existe mais quantidade ofertada para o produto')) {
                    const mensagem = (dados as any).Error.Error;
                    
                    // Usa uma expressão regular para capturar todas as mensagens de produto
                    const matches = mensagem.match(/Não existe mais quantidade ofertada para o produto \[\d+\]/g);

                    // Utiliza um Set para eliminar duplicatas
                    const unicos = Array.from(new Set(matches));

                    // Junta as mensagens sem repetição
                    const resultado = unicos.join('<br>');
                    globalMU.limparErrorMensage()
                    globalMU.showErrorMessage(resultado);
                }
            }
        } catch (erro) {
            setProcessando(false)
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
        }
    }

    const liberarPendencias = async (liberarPendencia: LiberarPendencia) => {
        try {
            globalMU.blockUI()

            const data = await liberarPendenciaOrcamento(
                orcamento.IdentificadorOrcamento,
                liberarPendencia.motivoLiberacaoPendencia,
                liberarPendencia.senhaLiberacaoPendencia
            )


            await obterDadosFinalizarOrcamento()

        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onPerguntaRespondida = async (codigo: string, resposta: boolean) => {

        dadosFinalizarOrcamento.DadosFinalizarOrcamento.Inconsistencias.forEach(tipoInconsistencia => tipoInconsistencia.Inconsistencias.forEach(inconsistencia => {
            if (inconsistencia.Codigo === codigo) {
                inconsistencia.Resposta = resposta
            }
        }))
        if (isMounted.current) {
            setDadosFinalizarOrcamento(dadosFinalizarOrcamento)
        }

        if (resposta && codigo === "#ID_PERGUNTA_PRODUTOS_PARA_ENTREGA_PELO_CD#") 
            { // 423918/345314
                const dados = await microuniversoApi.Orcamento.responderPerguntas( orcamento.IdentificadorOrcamento, dadosFinalizarOrcamento?.DadosFinalizarOrcamento?.Inconsistencias );
                await obterDadosFinalizarOrcamento() // 423918/345314 - precisa atualizar os dados para pegar pendencia de estoque (caso exista)
                globalMU.showInfoMessage("Filial de retirada alterada para CD!")
            }

        store.dispatch(gravarRespostaAction({ [codigo]: resposta }))
    }

    const esconderRegions = () => {
        document.getElementById('resumo-orcamento-region').style.display = 'none'
    }

    const onConfirmarComanda = async (numeroComanda: string) => {
        try {
            globalMU.blockUI()
            setComanda(numeroComanda)
            const resposta = await microuniversoApi.Orcamento.definirNumeroComanda( orcamento.IdentificadorOrcamento, numeroComanda)
            if (!("Error" in resposta)) {
                store.dispatch(sobrescreverInformacoesAction({ NumeroComanda: resposta.NumeroComanda }))
                if (isMounted.current) {
                    setComanda(resposta.NumeroComanda)
                }
                globalMU.showSuccessMessage("Número comanda definido com sucesso!")
            } else {
                setComanda(orcamento.NumeroComanda)
            }
        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onLimparResponsavelExecutor = async () => {
        try{
            globalMU.blockUI()
            const resposta = await microuniversoApi.Orcamento.limparResponsavelExecutor(orcamento.IdentificadorOrcamento)
            if (resposta) {
                await obterDadosFinalizarOrcamento()
            }
        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }

    }

    const onConfirmarResponsavelExecutor = async (agregadosSelecionados: ResponsaveisServicoAgregado[]) => {
        try {
            globalMU.blockUI()
            let todosExecutoresSelecionados = true
            
            if (agregadosSelecionados.some((value) => value.ExecutorOid <= 7)) {
                globalMU.showInfoMessage("Selecione um executor para todos os serviços listados.");
                todosExecutoresSelecionados = false;
            }

            const resposta = await microuniversoApi.Orcamento.definirResponsavelExecutor(
                orcamento.IdentificadorOrcamento, 
                agregadosSelecionados.map((value) => {
                    return {
                        IdentificadorItem: value.IdentificadorItem,
                        CodProTextoPadrao: value.CodigoServico,
                        DescricaoServico: value.DescricaoServico,
                        OidFuncionarioExecutor: value.ExecutorOid,
                        Valor: value.Valor,
                        TaxaIss: value.TaxaIss,
                        ServicoEmbutidoValorProduto: value.ServicoEmbutidoValorProduto
                    }
                })
            )
            if (resposta) {
                if (todosExecutoresSelecionados) {
                    globalMU.showSuccessMessage("Responsável executor definido com sucesso!")
                }
                await obterDadosFinalizarOrcamento()
            }
        } catch (erro) {
            tratamentoErroPadrao(erro)
        } finally {
            globalMU.unblockUI()
        }
    }

    useEffect(() => {
        const executarFuncoes = async () => {
            await Promise.all([
                esconderRegions(),
                atualizarParametros(),
                obterDadosFinalizarOrcamento(),
                obterVendedor()
            ])
        }

        executarFuncoes()
    }, [orcamento?.IdentificadorOrcamento])

 useEffect(() => {
        if (! processando && parametros.length > 0 && orcamento != null && orcamento.TipoOrcamento != 2 //Orc transfernecia
                        && ( orcamento.CodigoCliente == null ||  orcamento.CodigoCliente == undefined || orcamento.CodigoCliente <= 7 ) // 469361
                        && valorParametro("BLOQUEAR_INCLUSAO_DE_ORCAMENTO_SEM_CLIENTE") == "S")
        {
            let mensagem = "Obrigatório informar o cliente para continuar.</br></br>Você será redirecionado para a seleção de cliente."
            if (orcamento.OidUsuarioLogado <= 10)
            {
                mensagem += "</br></br>Veja parâmetro: <b>Bloquear a inclusão de orçamento sem cliente?</b>"
            }
            globalMU.showErrorMessage(mensagem)
            renderizarComponentReact(<PesquisarClienteContainer regiaoRenderizada='conteudo-pagina' />, "conteudo-pagina", true)
        }
    }, [parametros, orcamento?.Cliente, orcamento?.CodigoCliente, orcamento.TipoOrcamento])

    return <>



        {dadosCarregados && <> {
            tela == "FINALIZAR_ORCAMENTO" ? <>

                <Breadcrumb2
                    key={`FinalizarorcamentoContainer_Breadcrumb2`}
                    id="FinalizarorcamentoContainer_Breadcrumb2"
                    passos={["Finalizar Orçamento"]} />
                    
                <FinalizarOrcamento
                    onSituacaoAlterada={mudarSituacaoOrcamento}
                    dadosFinalizarOrcamento={dadosFinalizarOrcamento?.DadosFinalizarOrcamento}
                    exibirComandaFreteLoja={dadosFinalizarOrcamento.ComandaFreteLoja}
                    definirRespostaInconsistencia={onPerguntaRespondida}
                    processando={processando}
                    encerrarOrcamento={salvar}
                    formLiberarPendencias={mostrarFormLiberarPendencias}
                    liberarPendencias={liberarPendencias}
                    orcamento={orcamento}
                    respostasFinalizacaoOrcamento={respostasFinalizacaoOrcamento}
                    aguardandoProcessamento={aguardandoProcessamento}
                    numeroComanda={comanda}
                    onNumeroComandaAlterada={setComanda}
                    onConfirmarComanda={onConfirmarComanda}
                    onConfirmarResponsavelExecutor={onConfirmarResponsavelExecutor}
                    onLimparResponsavelExecutor={onLimparResponsavelExecutor}
                    //bloquearInclusaoDeOrcamentoSemCliente={valorParametro("BLOQUEAR_INCLUSAO_DE_ORCAMENTO_SEM_CLIENTE") == "S"}
                />

                {dadosFinalizarOrcamento?.DadosFinalizarOrcamento?.CalendarioCapacidadeCarga &&
                    <DisponibilidadeCapacidadeCargaContainer
                        dadosValidacao={dadosFinalizarOrcamento?.DadosFinalizarOrcamento.ValidacaoCapacidadeCargaItens}
                        codigoRoteiro={dadosFinalizarOrcamento?.DadosFinalizarOrcamento?.Roteiro}
                        onDatasConfirmadas={obterDadosFinalizarOrcamento}
                    />}
            </>
                :
                <OrcamentoConcluidoContainer 
                
                    orcamento={dadosOrcamentoFinalizado} 
                    vendedorLogado={vendedorLogado}
                />

        }</>}
        <section style={{ marginBottom: "100px" }} />
    </>
})
